import { useState, useEffect } from "react";
import { useCustomizationStore } from "features/ManageWebpage/modules/Customizations/store/useCustomizationStore";
import { useWebpageSectionChange } from "features/ManageWebpage/modules/Customizations/store/useWebpageSectionChange";
import { CUSTOMIZATION_SECTIONKEYS } from "features/ManageWebpage/modules/Customizations/common/utils/Customization.constants";

export const useTabTitle = () => {
  const sectionConfig = useCustomizationStore((state) => state.sectionConfig);
  const sectionValue =
    sectionConfig[CUSTOMIZATION_SECTIONKEYS.TAB_TITLE]?.value;

  const [tabTitle, setTabTitle] = useState(sectionValue || "");
  const { handleSectionChange } = useWebpageSectionChange();

  useEffect(() => {
    if (sectionValue !== undefined && sectionValue !== null) {
      setTabTitle(sectionValue);
    }
  }, [sectionValue]);

  const handleChange = (e) => {
    setTabTitle(e.target.value);
  };

  const handleBlur = () => {
    const payload = {
      feature_key: CUSTOMIZATION_SECTIONKEYS.TAB_TITLE,
      feature_value: tabTitle,
    };
    handleSectionChange({ payload });
  };

  return {
    tabTitle,
    handleChange,
    handleBlur,
  };
};
